import { ClassNameProps, ScrollContainerProps } from "@/types";
import { AssetResponse } from "@/utils/FetchAssetDetails/types";

enum ClipsVariant {
  Clips = "clips",
  Highlights = "highlights",
}

/**
 * Props for the ClipsTile component
 *
 * @remarks
 * ClipsTile is used to display Can't Miss Clips and Highlights Tiles
 */
interface ClipsTileProps
  extends ClassNameProps,
    ScrollContainerProps,
    React.HTMLAttributes<HTMLDivElement> {
  /**
   * The asset data to be displayed in the tile
   * Required when not in loading state
   */
  asset?: AssetResponse;

  /** Variant of the clip tile, either "clips" for series clips or "highlights" for NBA clips. Defaults to "clips" */
  variant?: ClipsVariant;

  /** Optional index for the clip tile within the scroll container */
  index?: number;

  /** Optional delay for autoplaying the video in ms*/
  delay?: number;

  /** Optional threshold for when the tile is considered in view and should play*/
  visibilityThreshold?: number;

  /** Optional ref for the tile container */
  tileContainerRef?: React.Ref<HTMLDivElement>;
}

export { ClipsVariant };
export type { ClipsTileProps };
